export default __webpack_public_path__ + "media/images/mailer/icon_reply-05e7be76b12b1b5529bd003bbe17bcf2.png";